import { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'

type followBrandEventArgs = {
  brandId: number
  isFollowEvent: boolean
}

type FollowBrandEventExtra = {
  brand_id: number
}

export const followBrandEvent = ({
  brandId,
  isFollowEvent,
}: followBrandEventArgs): TrackingEvent => {
  const eventName = isFollowEvent ? 'user.follow_brand' : 'user.unfollow_brand'

  const extra: FollowBrandEventExtra = {
    brand_id: brandId,
  }

  return {
    event: eventName,
    extra,
  }
}
